import Vue from 'vue'
import Vuex from 'vuex'

import I18n from 'i18n-js/index.js.erb'

import flatMap from 'lodash-es/flatMap'

import translateFilter from '@/vue/filters/translate'
import ApplyButton from '../job/apply_button.vue'
import Modal from '../components/modal.vue'
import FilterSummary from '../components/filter_summary.vue'
import FilterSettings from '../components/filter_settings.vue'
import PhdTest from '../phd_test/phd_test.vue'

import SvgIcon from '@/vue/components/svg_icon.vue'

import scrollsIntoView from '@/vue/directives/scrolls_into_view'
import { clickTrack, trackingContext } from '@/vue/directives/tracking'

import storeConfig from '../store'

I18n.defaultLocale = global.I18n.defaultLocale
I18n.locale = global.I18n.locale

Vue.component('svg-icon', SvgIcon)

Vue.filter('t', translateFilter(I18n))

Vue.directive('scrolls-into-view', scrollsIntoView)
Vue.directive('tracking-context', trackingContext)
Vue.directive('click-track', clickTrack)

Vue.use(Vuex)

const components = { ApplyButton, FilterSettings, FilterSummary, Modal, PhdTest }
const store = new Vuex.Store(storeConfig)

store.replaceState({ ...store.state, ...(global.VuexStore || {}) })

const mountVueComponents = () => {
  Object.entries(components).forEach(([componentName, component]) => {
    const className = `nyx-${componentName}`

    flatMap([...document.getElementsByClassName(className)], el => {
      // Don't mount an element that already belongs to a Vue instance
      if (!el.__vue__) {
        const props = JSON.parse(el.dataset.props || '{}')
        // Make sure store is ready before mounting components (mainly to cope with legacy code)
        setTimeout(() => {
          new Vue({ store, el, render: h => h(component, { props }) })
        })
      }
    })
  })
}

EventBus.on('vue:mount', mountVueComponents)

document.addEventListener('DOMContentLoaded', () => {
  mountVueComponents()
})
